import React, { FC } from 'react';

import { StyledBlogCard } from './styled/StyledBlogCard';
import { BlogCardT } from './types';
import { calculateReadingTime } from '@lib/utils/calcReadTime/calcReadTime';
import { getExcerpt } from '@lib/utils/getExcerpt/getExcerpt';
import Link from 'next/link';
import { renderImage } from '@lib/utils';
import { Format } from '@lib/types';
import { ReadingTime } from '@components/Atoms/ReadingTime/ReadingTime';
import ArrowRight from '@public/arrow_chev_right.svg';
import { Icon } from '@components/Atoms';
import { BlogHeader } from '../BlogHeader/BlogHeader';

export const BlogCard: FC<BlogCardT> = ({
  blog_title,
  categories,
  featured_image,
  excerpt,
  published_at,
  slug,
  blog_content,
  postType = 'blog',
}) => {
  const readTime = calculateReadingTime(blog_content);
  excerpt = getExcerpt(excerpt, 150);
  const headerProps = { blog_title, published_at, categories };

  return (
    <StyledBlogCard className="h-full">
      <Link href={`/${postType}/${slug}`} passHref>
        <div className="blog-card">
          {renderImage({
            className: `blog-card__feature-image`,
            alternativeText: featured_image.alternativeText,
            formats: featured_image.formats,
            format: Format.SMALL,
          })}
          <div className="blog-card__content">
            <BlogHeader {...headerProps} headingLevel={'h4'} />
            <ReadingTime>
              <small className="reading-time">
                <span className="reading-time__pre-text">Reading time</span> {readTime} mins
              </small>
            </ReadingTime>
            {excerpt && <p>{excerpt}</p>}
            <div className="blog-card__link">
              <>
                <p>More Info</p>
                <span>
                  <Icon xs icon={ArrowRight} />
                </span>
              </>
            </div>
          </div>
        </div>
      </Link>
    </StyledBlogCard>
  );
};
